import React from "react";
import Lottie from "lottie-react";
import robotAnimation from "../wa-lottie.json";

const style = {
  height: 80,
  width: 80,
  position: "fixed",
  bottom: "40px",
  right: "20px",
  zIndex: 9999,
  cursor: "pointer", // Menambahkan kursor pointer saat diarahkan ke atas
};

const whatsappNumber = "6281212851807"; // Ganti dengan nomor WhatsApp yang ingin Anda gunakan

const Example = () => {
  const handleClick = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}`;
    window.open(whatsappLink, "hello"); // Membuka tautan WhatsApp dalam tab baru
  };

  return (
    <div style={style} onClick={handleClick}>
      <Lottie animationData={robotAnimation} loop={true} />
    </div>
  );
};

export default Example;
